import type { FunctionComponent } from "react";

type SubmitButtonProps = {
  text: string;
  type?: "submit" | "button";
  disabled?: boolean;
  onClick?: () => void;
};

export const SubmitButton: FunctionComponent<SubmitButtonProps> = ({
  text,
  type = "button",
  disabled = false,
  onClick,
}: SubmitButtonProps) => {
  return (
    <button
      data-testid={"submit-button"}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${disabled ? "bg-primary-100" : "bg-primary"} w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline`}
    >
      {text}
    </button>
  );
};
